import { useCallback, useMemo, useState } from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';

const RESET_LABEL_TIMER = 3000;

type ShareData = {
	buttonLabel: TranslationKey;
	buttonLabelReplacement?: Record<string, string>;
};
type ShareActions = { afterShare: () => void };
type UseDefaultShareButtonResult = ModelHookResult<ShareData, ShareActions>;
type UseShareButtonArgs = {
	label: TranslationKey;
	successLabel?: TranslationKey;
	labelReplacements?: Record<string, string>;
};

export function useRoundShareIconButton({
	label,
	successLabel,
	labelReplacements,
}: UseShareButtonArgs): UseDefaultShareButtonResult {
	const [clickedState, setClickedState] = useState(false);

	const afterShare = useCallback(() => {
		if (successLabel) {
			setClickedState(true);
			// Timeout to reset the style
			window.setTimeout(() => {
				setClickedState(false);
			}, RESET_LABEL_TIMER);
		}
	}, [setClickedState, successLabel]);

	const buttonLabel = useMemo(
		() => (successLabel && clickedState ? successLabel : label),
		[clickedState, successLabel, label],
	);

	return {
		data: { buttonLabel, buttonLabelReplacement: labelReplacements },
		actions: { afterShare },
	};
}
